import {createEventListener} from "./tools";
import {debounce} from "throttle-debounce";

export default function($app) {
	createEventListener(this);

	this.isFocused = ko.observable(false);
	this.isShowError = ko.observable(false);
	this.showError = () => this.isShowError(true);
	this.hideError = () => this.isShowError(false);

	let embedErrorTimer = setTimeout(() => {
		console.warn('Player Embed Script:', 'Not Found');

		this.showError();
	}, 1000);

	this.sendMessage = (type, data) => {
		const message = {
			[type]: data,
		};
		parent.postMessage(JSON.stringify(message), '*');

		return this;
	};

	window.addEventListener('message', (event) => {
		try {
            const data = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
            for(let type in data) {
                if(data.hasOwnProperty(type)) {
                    this.trigger(type, data[type]);
                }
            }
		} catch(e) {
		}
	});

	window.addEventListener('blur', () => this.isFocused(false));
	window.addEventListener('focus', () => this.isFocused(true));
	window.addEventListener('mousedown', () => this.isFocused(true));
	window.addEventListener('touchstart', () => this.isFocused(true));

	this.isFocused.subscribe(isFocused => this.sendMessage('playerFocus', isFocused));

	this
		.sendMessage('embedCheck', true)
		.on('embedConfirm', () => {
			console.info('Player Embed Script:', 'OK');
			clearTimeout(embedErrorTimer);
			this.hideError();
		})
		.on('logout', () => $app.require('auth').logout())
		.on('setCurrentTime', (currentTime) => $app.$player.setCurrentTime(currentTime))
		.on('setEpisode', (id) => {
			const episode = $app.event().episode().find((ep) => ep.id() === id || ep.key() === id);
			if (!episode) {
				console.warn('Cant find episode', id);

				return;
			}
			$app.setEpisode(episode);
		})
        .on('setEpisodeByExternalId', (externalId) => {
            const episode = $app.event().episode().find(ep => ep.externalId() === externalId);
            if (!episode) {
                console.warn('Cant find episode by external id', externalId);

                return;
            }
            $app.setEpisode(episode);
        })
		.on('style', (style) => {
			if(!$app.event()) return;

			Object.keys(style).forEach((key) => {
				if(key.match(/Color$/) && $app.event().moduleTheme[key]) {
					$app.event().moduleTheme[key](style[key]);
				}
			});
		})
	;

	let lastCurrentTime = -100;
	$app.require('player').on('currentTime', (currentTime) => {
		if (Math.abs(lastCurrentTime - currentTime) > 5) {
			const stream = $app.currentStream();
			if (!stream) {
				return;
			}

			let absoluteTime = stream.getAbsoluteTimeByPlayerTime(currentTime);

			this.sendMessage('currentTime', {currentTime, absoluteTime});
		}
		lastCurrentTime = currentTime;
	});

	$app.currentStream.subscribe(() => {
		lastCurrentTime = -100;
	});

	$app.currentEpisode.subscribe(debounce(500, episode => {
		let message = null;
		if (episode) {
			message = {
				id: episode.id(),
				key: episode.key(),
                externalId: episode.externalId(),
				nameRu: episode.name_ru(),
				nameEn: episode.name_en(),
				descriptionRu: episode.info_ru(),
				descriptionEn: episode.info_en(),
				timeStart: episode.timeStart(),
				timeStop: episode.timeStop(),
			};
		}

		this.sendMessage('currentEpisode', message);
	}, {atBegin: false}));
};
